import HandsWhite from "../images/customisation-assets/Hands_White.png";
import HandsAqua from "../images/customisation-assets/Hands_Aqua.png";
import HandsBlack from "../images/customisation-assets/Hands_Black.png";
import HandsBlue from "../images/customisation-assets/Hands_Blue.png";
import HandsOrange from "../images/customisation-assets/Hands_Orange.png";
import HandsRed from "../images/customisation-assets/Hands_Red.png";
import HandsSand from "../images/customisation-assets/Hands_Sand.png";
import HandsYellow from "../images/customisation-assets/Hands_Yellow.png";
import HandsPink from "../images/customisation-assets/Hands_Pink.png";
import HandsSteelBlue from "../images/customisation-assets/Hands_Steel_Blue.png";
import HandsBlackOrange from "../images/customisation-assets/Hands_Black_Orange.png";
import HandsBlackRed from "../images/customisation-assets/Hands_Black_Red.png";
import HandsBlackAqua from "../images/customisation-assets/Hands_Black_Aqua.png";
import HandsBlackYellow from "../images/customisation-assets/Hands_Black_Yellow.png";
import HandsGreen from "../images/customisation-assets/Hands_Green.png";
import HandsGold from "../images/customisation-assets/Hands_Gold.png";

// Thumbnails
import HandsAquaThumb from "../images/customisation-asset-thumbnails/Hands_Aqua_50x50.png";
import HandsBlackThumb from "../images/customisation-asset-thumbnails/Hands_Black_50x50.png";
import HandsBlueThumb from "../images/customisation-asset-thumbnails/Hands_Blue_50x50.png";
import HandsOrangeThumb from "../images/customisation-asset-thumbnails/Hands_Orange_50x50.png";
import HandsWhiteThumb from "../images/customisation-asset-thumbnails/Hands_White_50x50.png";
import HandsRedThumb from "../images/customisation-asset-thumbnails/Hands_Red_50x50.png";
import HandsSandThumb from "../images/customisation-asset-thumbnails/Hands_Sand_50x50.png";
import HandsYellowThumb from "../images/customisation-asset-thumbnails/Hands_Yellow_50x50.png";
import HandsPinkThumb from "../images/customisation-asset-thumbnails/Hands_Pink_50x50.png";
import HandsSteelBlueThumb from "../images/customisation-asset-thumbnails/Hands_Steel_Blue_50x50.png";
import HandsBlackOrangeThumb from "../images/customisation-asset-thumbnails/Hands_Black_Orange_50x50.png";
import HandsBlackYellowThumb from "../images/customisation-asset-thumbnails/Hands_Black_Yellow_50x50.png";
import HandsBlackRedThumb from "../images/customisation-asset-thumbnails/Hands_Black_Red_50x50.png";
import HandsBlackAquaThumb from "../images/customisation-asset-thumbnails/Hands_Black_Aqua_50x50.png";
import HandsGreenThumb from "../images/customisation-asset-thumbnails/Hands_Green_50x50.png";
import HandsGoldThumb from "../images/customisation-asset-thumbnails/Hands_Gold_50x50.png";

import { SelectionColours } from "./selection-colors";

export const HANDS_OPTIONS = {
  aqua: {
    title: "Aqua & White",
    watchLayerAsset: HandsAqua,
    watchLayerThumbnail: HandsAquaThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.AQUA, SelectionColours.WHITE],
    },
  },
  black: {
    title: "Black & White",
    watchLayerAsset: HandsBlack,
    watchLayerThumbnail: HandsBlackThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.LIGHT_BLACK, SelectionColours.WHITE],
    },
  },
  blue: {
    title: "Blue & White",
    watchLayerAsset: HandsBlue,
    watchLayerThumbnail: HandsBlueThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BLUE, SelectionColours.WHITE],
    },
  },
  orange: {
    title: "Orange & White",
    watchLayerAsset: HandsOrange,
    watchLayerThumbnail: HandsOrangeThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.ORANGE, SelectionColours.WHITE],
    },
  },
  red: {
    title: "Red & White",
    watchLayerAsset: HandsRed,
    watchLayerThumbnail: HandsRedThumb,
    selectionAsset: {
      type: "color",
      colors: ["#980000", SelectionColours.WHITE],
    },
  },
  sand: {
    title: "Sand & White",
    watchLayerAsset: HandsSand,
    watchLayerThumbnail: HandsSandThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.SAND, SelectionColours.WHITE],
    },
  },
  yellow: {
    title: "Yellow & White",
    watchLayerAsset: HandsYellow,
    watchLayerThumbnail: HandsYellowThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.YELLOW, SelectionColours.WHITE],
    },
  },
  white: {
    title: "White",
    watchLayerAsset: HandsWhite,
    watchLayerThumbnail: HandsWhiteThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.WHITE],
    },
  },
  pink: {
    title: "Pink & Black",
    watchLayerAsset: HandsPink,
    watchLayerThumbnail: HandsPinkThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.BABY_PINK, SelectionColours.BLACK],
    },
  },
  steelBlue: {
    title: "Steel & Blue",
    watchLayerAsset: HandsSteelBlue,
    watchLayerThumbnail: HandsSteelBlueThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.STEEL_BLUE, SelectionColours.DARK_BLUE],
    },
  },
  blackOrange: {
    title: "Orange & Black",
    watchLayerAsset: HandsBlackOrange,
    watchLayerThumbnail: HandsBlackOrangeThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.ORANGE, SelectionColours.BLACK],
    },
  },
  blackYellow: {
    title: "Yellow & Black",
    watchLayerAsset: HandsBlackYellow,
    watchLayerThumbnail: HandsBlackYellowThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.SUNSHINE_YELLOW, SelectionColours.BLACK],
    },
  },
  blackRed: {
    title: "Red & Black",
    watchLayerAsset: HandsBlackRed,
    watchLayerThumbnail: HandsBlackRedThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.RED, SelectionColours.BLACK],
    },
  },
  blackAqua: {
    title: "Aqua & Black",
    watchLayerAsset: HandsBlackAqua,
    watchLayerThumbnail: HandsBlackAquaThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.AQUA, SelectionColours.BLACK],
    },
  },
  green: {
    title: "Green & Black",
    watchLayerAsset: HandsGreen,
    watchLayerThumbnail: HandsGreenThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.FOREST_GREEN, SelectionColours.BLACK],
    },
  },
  gold: {
    title: "Gold & Black",
    watchLayerAsset: HandsGold,
    watchLayerThumbnail: HandsGoldThumb,
    selectionAsset: {
      type: "color",
      colors: [SelectionColours.GOLD, SelectionColours.BLACK],
    },
  },
};
